import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Client } from 'resteasytox';

@Injectable()
export class ResteasyClientFactoryService {

	constructor() { }

	/**
	 * Creates a RESTEasy client configured for session-based authentication
	 * This ensures that JSESSIONID cookies are included in all requests
	 */
	createAuthenticatedClient(baseUrl: string = environment.apiUrl + '/'): Client {
		const client: Client = new Client(baseUrl);
		// Configure the client to include cookies by setting withCredentials
		// This ensures JSESSIONID cookies are sent with all requests
		(client as any).withCredentials = true;
		// Override the client's request method to ensure cookies are included
		const originalRequest: any = (client as any).request;
		if (originalRequest) {
			(client as any).request = function(options: any): any {
				// Ensure cookies are included in the request
				if (!options.headers) {
					options.headers = {};
				}
				options.headers['Cookie'] = document.cookie;
				options.headers['X-Requested-With'] = 'XMLHttpRequest';
				options.withCredentials = true;
				return originalRequest.call(this, options);
			};
		}
		return client;
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/resteasy-client-factory.service.ts